import { AppThunk } from 'store';

import { MirrorService } from 'services/MirrorService';

import { AuthApi } from 'api/AuthApi';
import { PaymentApi } from 'api/PaymentApi';
import { CREDITS_WELCOME_PACK_SESSION_STORAGE_KEY } from 'helpers/constants';
import { getSessionStorageItem } from 'helpers/sessionStorage';
import { getOptimizedCreditPackages } from 'helpers/splits/optimizeCreditPrice';
import { setUser } from 'store/auth/authSlice';
import { setPackages } from 'store/payment/thunks';
import {
  setActiveSystemPopup,
  SystemPopupTypes,
} from 'store/systemPopup/systemPopupSlice';

import { setInitState, setLoading } from './commonSlice';

export const init = (): AppThunk => async (dispatch, getState) => {
  const state = getState();

  dispatch(setLoading(true));

  const initData = await AuthApi.init({
    from: state.common.prevPageHref,
  });
  const paymentInfoData = await PaymentApi.paymentInfo();

  dispatch(setUser(initData.user));

  if (paymentInfoData.is_credits_price_optimization) {
    const credit_packages = getOptimizedCreditPackages(
      paymentInfoData.payment.credit_packages
    );

    const updatedPayment = {
      ...paymentInfoData.payment,
      credit_packages,
    };

    dispatch(setPackages(updatedPayment));
  } else {
    dispatch(setPackages(paymentInfoData.payment));
  }

  dispatch(
    setInitState({
      loading: false,
      popups: {
        hasMatch: null,
      },

      newDialogsCount: initData.dialogs.count_new,
      hasNotifications: initData.has_notifications,
      popularUsers: initData.popular_users,
      currentLang: initData.site_language.value,
      supportedLangs: initData.site_language.options,
      translations: {
        isEnabled: initData.translation.enabled,
        buildVersion: String(initData.translation.build_id),
      },
      boostExpireDate: initData.vip_boost_expired_at,
      featureFlags: {
        isAdsEnabled: initData.can_see_ads,
        isNativeAdsEnabled: initData.can_see_native_ads,
        isCanShowRetentionPopup: initData.show_retention_popup,
        isCanShowGiftCreditsPopup: initData.show_gift_credits_popup,
        isPromoteVipPopupEnabled: initData.is_custom_vip_funnel_enabled,
        isPaymentFormIntentEnabled: initData.is_intent_form_enabled,
        isComplianceStatementEnabled: initData.is_compliance_statement_enabled,
        isStaticPopularUsersPhotoEnabled:
          initData.is_static_popular_users_photo_enabled,
        isCarouselPaywallEnabled: initData.is_carousel_paywall_v4_enabled,
        isCompliancePaywallEnabled: initData.is_compliance_paywall,
        isRetentionFunnelsEnabled: initData.is_retention_activity,
        isFreeVipEnabled: initData.is_free_vip_enabled,
        isUpgradeDarkThemeEnabled: initData.is_dates_me_paywall,
        isOrganicPartnerId: initData.is_organic_partner_id,
        isNeedAgeVerificationEnabled: initData.need_age_verification,
        isPaywallMonthPackageEnabled: initData.is_month_package,
        isLimitTimeOfferEnabled: paymentInfoData.has_limit_time_offer,
        isAdditionalPriceEnabled: paymentInfoData.is_additional_price,
        is3dPackageEnabled: paymentInfoData.is_3d_split,
        isErrorTranslateEnabled: paymentInfoData.is_error_translate,
        isJoinFeeEnabled: paymentInfoData.is_join_fee,
        isCreditsPriceOptimizationEnabled:
          paymentInfoData.is_credits_price_optimization,
        isComericaBankEnabled: paymentInfoData.is_comerica_bank,
      },
    })
  );

  if (
    initData.show_gift_credits_popup &&
    !MirrorService.isGoogleCertificationsGroup
  ) {
    dispatch(
      setActiveSystemPopup({
        type: SystemPopupTypes.CreditsWelcomeGift,
        params: {
          isNewUser: getSessionStorageItem(
            CREDITS_WELCOME_PACK_SESSION_STORAGE_KEY
          ),
        },
      })
    );
  }
};
